export default __webpack_public_path__ + "static/media/Baby9.2ce66539.gif";